import React from "react";
import { useContext } from "react";

import StoreContext from "../../Store/code-context";

import ProjectForm from "../ProjectForm/ProjectForm";
import classes from "./BodyMain.module.css";
export default function BodyMain(props) {
  const storeCtx = useContext(StoreContext);

  const submitFormHandler = (projectName) => {
    const data = {
      id: storeCtx.appData.length,
      projectName: projectName.trim(),
    };
    storeCtx.setPrefix(data.projectName);
    storeCtx.addData(data);
    // console.log(storeCtx.appData, data);

    props.onprojectCreation(false);
  };
  const clickHandle = (event) => {
    const id = event.target.id;
    const data1 = storeCtx.appData.filter((val) => {
      return (val.id = id);
    });
    // storeCtx.setPrefix("");
    const name = data1[0].projectName;
    storeCtx.setPrefix(name);

    storeCtx.IsFile(true);
  };
  const projectElements = storeCtx.appData.map((val) => {
    return (
      <div key={val.id} id={val.id} onClick={clickHandle}>
        {val.projectName}
      </div>
    );
  });
  return (
    <div className={classes.main}>
      {props.onshow && <ProjectForm onSubmitForm={submitFormHandler} />}
      <div className={classes.projects}>{projectElements}</div>
    </div>
  );
}
